import React from 'react'
import PageHeader from '../components/PageHeader'
import VideoGalleryComponent from '../components/VideoGalleryComponent'

const VideoGalleryPage = () => {
  return (
   <>
   
   <PageHeader title="व्हिडिओ संग्रह " path="/about-goshala" name=" goshala" />
   <VideoGalleryComponent/>
   </>
  )
}

export default VideoGalleryPage